module.exports = __webpack_public_path__ + "img/design-file.187ca01e.svg";